export const ApplicationType = {
    ADMIN: 'ADMIN'
};
